import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import type * as Types from './types';
import * as Models from './models';

export const describe = (institutionId: string, filtersAndColumnsKind: Types.FiltersAndColumnsKind) => {
    return RESTClient.getAuthenticatedObservable('v2/filter/describe', {
        institution: institutionId,
        kind: filtersAndColumnsKind,
    }).map(response => {
        return Models.FiltersAndColumns.fromAPI(response);
    });
};

export const createList = (institutionId: string, name: string, filter: string, kind: Types.FiltersAndColumnsKind) => {
    return RESTClient.postAuthenticatedObservable('v2/filter/presets', {
        institutionId,
        name,
        filter,
        kind,
    });
};

export const updateList = (presetId: string, name: string, filter: string) => {
    return RESTClient.putAuthenticatedObservable(`v2/filter/presets/${presetId}`, {
        name,
        filter,
    });
};
